import {
  findIndexByPropertyValue
} from 'utilities/collection';

import PageEventDefinitions from './page-event-definitions';
import StartupMembers from './members';
import SocialNetworkOperators from './social-network-operators';

class Startup {

  constructor(startupData, supportingData = {}, modules) {

    this.divisionIdentitiesLoaded = true;
    this.customerFiltersLoaded = true;
    this.countryCodesLoaded = true;

    this.startupPlanLoaded = Boolean(supportingData.startupPlan);

    this.divisionIdentities = supportingData.divisionIdentities || [];
    this.customerFilters = supportingData.customerFilters || [];
    this.countryCodes = supportingData.countryCodes || [];
    this.startupPlan = supportingData.startupPlan || null;

    this.data = startupData;
    this.application = modules.application;
    this.serverInterface = modules.serverInterface;

    this.pageEventDefinitions = new PageEventDefinitions();
    this.members = new StartupMembers(this.data, supportingData, modules);

    this.socialNetworkOperators = new SocialNetworkOperators(this.serverInterface);

  }

  setData(startupData) {
    this.data = startupData;
  }

  async initialize() {

  }

  async loadPrivateData() {

    await this.members.initialize();

  }

  async loadStartupPlan(forceLoad = false) {

    if (this.startupPlanLoaded === true && forceLoad === false) {
      return this.startupPlan;
    }

    this.startupPlan = await this.serverInterface.startup.getStartupPlan(this.data._id);

    this.startupPlanLoaded = true;

    return this.startupPlan;

  }

  trySetDivisionIdentity(divisionIdentityId, divisionIdentity) {

    const divisionIdentityIndex = findIndexByPropertyValue(this.divisionIdentities, '_id', divisionIdentityId);

    if (divisionIdentityIndex === -1) {
      return;
    }

    const oldDivisionIdentity = this.divisionIdentities[divisionIdentityIndex];

    this.divisionIdentities[divisionIdentityIndex] = {
      ...oldDivisionIdentity,
      ...divisionIdentity
    };

  }

  tryRemoveDivisionIdentity(divisionIdentityId) {

    const divisionIdentityIndex = findIndexByPropertyValue(this.divisionIdentities, '_id', divisionIdentityId);

    if (divisionIdentityIndex === -1) {
      return;
    }

    this.divisionIdentities.splice(divisionIdentityIndex, 1);

  }

  async createDivisionIdentity(divisionIdentity) {

    const newDivisionIdentity = await this.serverInterface.startup.divisionIdentities.createDivisionIdentity(divisionIdentity);

    this.divisionIdentities.push(newDivisionIdentity);

    return newDivisionIdentity;

  }

  async loadDivisionIdentities(forceLoad = false) {

    if (this.divisionIdentitiesLoaded === true && forceLoad === false) {
      return this.divisionIdentities;
    }

    this.divisionIdentities = await this.serverInterface.startup.divisionIdentities.getDivisionIdentities();

    this.divisionIdentitiesLoaded = true;

    return this.divisionIdentities;

  }

  async updateDivisionIdentity(divisionIdentityId, divisionIdentity) {

    const updated = await this.serverInterface.startup.divisionIdentities.updateDivisionIdentityById(divisionIdentityId, divisionIdentity);

    if (updated === true) {
      this.trySetDivisionIdentity(divisionIdentityId, divisionIdentity);
    }

    return updated;

  }

  async deleteDivisionIdentityById(divisionIdentityId) {

    const deleted = await this.serverInterface.startup.divisionIdentities.deleteDivisionIdentityById(divisionIdentityId);

    if (deleted === true) {
      this.tryRemoveDivisionIdentity(divisionIdentityId);
    }

    return deleted;

  }

  loadCustomerFilters(forceLoad = false) {

    if (this.customerFiltersLoaded === true && forceLoad === false) {
      return this.customerFilters;
    }

    this.customerFilters = this.application.dataManagers.get('CustomerFiltersManager').getAll();

    this.customerFiltersLoaded = true;

    return this.customerFilters;

  }

  async loadCountryCodes() {

    if (this.countryCodesLoaded === true) {
      return this.countryCodes;
    }

    this.countryCodes = await this.serverInterface.system.getCountryCodes();

    this.countryCodesLoaded = true;

    return this.countryCodes;

  }

  getDivisionIdentities() {

    return this.divisionIdentities;

  }

  isDivisionIdentity(id) {

    return this.divisionIdentities.findIndex(identity => identity._id === id) !== -1;

  }

  getCustomerFilters() {

    return this.customerFilters;

  }

  getCountryCodes() {

    return this.countryCodes;

  }

}

export default Startup;